// Compatibility, not authorization: only the server-held one-time grant can
// authorize recovery. Never retry recovery through the old force/key flow.
const RECOVERY_UPDATE_MESSAGE = 'Account recovery and email verification are temporarily unavailable. A service update is required. Please try again later; sign-in is still available.';
const RECOVERY_CAPABILITY_QUERY = `query AccountRecoveryCapability {
  __schema {
    queryType { fields { name args { name } } }
    mutationType { fields { name args { name } } }
  }
  recoveryResult: __type(name: "ResetData") { fields { name } }
}`;
function supportsAccountRecovery(response) {
  if (!response || response.errors?.length || !response.data) return false;
  const { __schema: schema, recoveryResult } = response.data;
  const list = value => Array.isArray(value) ? value : [];
  const query = list(schema?.queryType?.fields).find(field => field?.name === 'verifyUserCode');
  const mutation = list(schema?.mutationType?.fields).find(field => field?.name === 'updateUser');
  return list(query?.args).some(arg => arg?.name === 'purpose') &&
    list(mutation?.args).some(arg => arg?.name === 'recoveryGrant') &&
    list(recoveryResult?.fields).some(field => field?.name === 'recoveryGrant');
}
function isAccountRecoveryRequest(request) {
  const query = request?.query || '';
  return /\bverifyUserCode\s*\([^)]*\bpurpose\s*:/.test(query) ||
    /\bupdateUser\s*\([^)]*\brecoveryGrant\s*:/.test(query);
}
async function requireAccountRecoveryCapability(baseUrl, fetchRequest, headers) {
  // No persisted/client-supplied capability flag or cross-endpoint cache.
  // Probe contains only schema metadata: no email, code, password or grant.
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 5000);
  try {
    const response = await fetchRequest(baseUrl, {
      method: 'POST', headers, signal: controller.signal, body: JSON.stringify({ query: RECOVERY_CAPABILITY_QUERY }),
    });
    if (!response.ok || !supportsAccountRecovery(await response.json())) throw Error('unsupported');
  } catch (_) {
    const error = new Error(RECOVERY_UPDATE_MESSAGE);
    error.code = 'ACCOUNT_RECOVERY_SERVICE_UPDATE_REQUIRED';
    throw error;
  } finally { clearTimeout(timeout); }
}
module.exports = { RECOVERY_UPDATE_MESSAGE, RECOVERY_CAPABILITY_QUERY, supportsAccountRecovery,
  isAccountRecoveryRequest, requireAccountRecoveryCapability };
